import z from 'zod'

export const tabItems = ['national', 'province', 'city', 'district'] as const

export const searchParamsSchema = z.object({
  tab: z
    .string()
    .optional()
    .default('national')
    .transform(val => val as (typeof tabItems)[number]),
  province_code: z.string().optional(),
  city_code: z.string().optional(),
  district_code: z.string().optional()
})

export type SearchParams = z.infer<typeof searchParamsSchema>

export type TabItem = (typeof tabItems)[number]
